import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from '../Currency/Currency.module.sass';
import Icon from '../../../components/Icon';
import { FaStar } from 'react-icons/fa';
import { coinIcons } from './currenciesIcons';
import { getFavorites, handleFavorite } from './favourite';
import { usePricingMonitor } from 'hooks/usePricingMonitor';

const CurrencyRow = ({ data: x, onMarketSelect, onFavoriteToggle }) => {
  const clonedX  = JSON.parse(JSON.stringify({...x,instanceId:x.pairName.replace("/","-").toUpperCase()}))
  const pricingData = usePricingMonitor(clonedX.instanceId);
    const [isFavorite, setIsFavorite] = useState(false);
  
    useEffect(() => {
      const favorites = getFavorites();
      setIsFavorite(favorites.includes(clonedX._id));
    }, [clonedX._id]);
  
    const toggleFavorite = () => {
      handleFavorite(clonedX._id);
      setIsFavorite(!isFavorite);
      onFavoriteToggle();
    };
    const symbol = clonedX.instanceId?.split('-')[0]?.toLowerCase();
    const iconUrl = `https://huobicfg.s3.amazonaws.com/currency_icon/${symbol}.png`
      ? `https://huobicfg.s3.amazonaws.com/currency_icon/${symbol}.png`
      : coinIcons[symbol];

    return (
      <div
        className={styles.row}
        style={{ cursor: 'pointer' }}
        onClick={() => onMarketSelect(clonedX.instanceId)}
      >
        <div className={styles.col}>
          <div className={styles.line}>
            <button
              className={cn('favorite', styles.favorite)}
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite();
              }}
            >
              {isFavorite ? <FaStar /> : <Icon name="star-outline" size="16" />}
            </button>
  
            {
              <img
                src={iconUrl}
                alt={symbol}
                style={{ width: 20, height: 20 }}
              />
            }
  
            <div className={styles.info}>{clonedX.instanceId}</div>
          </div>
        </div>
  
        <div className={styles.col}>
          {parseFloat(
            pricingData?.close
          ).toFixed(6) || '-'}
        </div>
      </div>
    );
  };
  
  export default CurrencyRow;